import { makeStyles } from '@material-ui/core'

export default makeStyles({
  template: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  }
})
